// @flow
// I know this is a gross file but it's here because of the way I had to handle the graphql query
import React from 'react';
import { cx, css } from 'react-emotion';
import { components } from '@peachjar/components';

import UploadCSVContainer from '../components/UploadCSVContainer';
import UploadStatusBox from '../components/UploadStatusBox';

const { NumberedRow, Buttons } = components;
const { ButtonPrimaryLarge } = Buttons;

export const enableButton = (
  isUploading: boolean,
  isUploadingComplete: boolean,
  parentUploadingInstructionsClicked: boolean,
  parentUploadingTemplateCLicked: boolean,
  haveParentsBeenLoaded: boolean,
  graphqlLoading: boolean
): boolean => {
  if (haveParentsBeenLoaded) return true;

  if (
    graphqlLoading ||
    !parentUploadingInstructionsClicked ||
    !parentUploadingTemplateCLicked ||
    (isUploading && !isUploadingComplete)
  )
    return false;

  return true;
};

type Props = {
  isUploading: boolean,
  uploadingPercentage: number,
  isUploadComplete: boolean,
  uploadingFilename: string,
  validationErrors: Array<any>,
  status: string,
  totalCount: number,
  setParentUploadingFile: () => void,
  parentUploadingInstructionsClicked: boolean,
  parentUploadingTemplateCLicked: boolean,
  haveParentsBeenLoaded: boolean,
  handleTabView: number => void,
  graphqlLoading: boolean,
};

const UploadSectionWrapper = ({
  isUploading,
  uploadingPercentage,
  isUploadComplete,
  uploadingFilename,
  validationErrors,
  status,
  totalCount,
  setParentUploadingFile,
  parentUploadingInstructionsClicked,
  parentUploadingTemplateCLicked,
  haveParentsBeenLoaded,
  handleTabView,
  graphqlLoading,
}: Props) => (
  <NumberedRow rowNumber={2} headerText="Upload CSV File">
    {isUploading && (
      <UploadStatusBox
        uploadPercentage={uploadingPercentage}
        uploadComplete={isUploadComplete}
        filename={uploadingFilename}
        resetFileUpload={() => {}}
        errors={validationErrors}
        status={status}
        totalCount={totalCount}
      />
    )}
    <UploadCSVContainer
      showUploadMessage={isUploading}
      enableUploadButton={enableButton(
        isUploading,
        isUploadComplete,
        parentUploadingInstructionsClicked,
        parentUploadingTemplateCLicked,
        haveParentsBeenLoaded,
        graphqlLoading
      )}
      onChangeHandler={setParentUploadingFile}
    />
    <div
      className="justify-content-end"
      style={{
        display: 'flex',
        width: '920px',
        marginTop: '24px',
      }}
    >
      {/*
            TODO: Break this out.
            For some reason this button doesn't rerender when
            the state is toggled
          */}
      <ButtonPrimaryLarge
        data-testid="click-continue"
        className={cx(styles.continueButton, 'parent-continue-button')}
        onClick={() => {
          if (
            haveParentsBeenLoaded ||
            (!(validationErrors || []).length && status === 'completed')
          )
            handleTabView(2);
        }}
        disabled={
          !(
            haveParentsBeenLoaded ||
            (!(validationErrors || []).length && status === 'completed')
          )
        }
      >
        Continue
      </ButtonPrimaryLarge>
    </div>
  </NumberedRow>
);

export default UploadSectionWrapper;

const styles = {
  continueButton: css`
    margin-right: 0;
  `,
};



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/parent/components/UploadSectionWrapper.jsx